(function() {
    'use strict';

    angular.module('tags.constants', [])
        .constant('tagsMessagesConst', {
            add: 'Dodano tag!',
            update: 'Tag został zaktualizowany!',
            delete: 'Tag został usunięty!',
            error: 'Wystąpił bład!'
        })
        .constant('tagsPermissionsConst', {
            view: {
                value: 'view_tag',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu tagu!'
            },
            add: {
                value: 'add_tag',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania tagu!'
            },
            update: {
                value: 'change_tag',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji tagu!'
            },
            delete: {
                value: 'delete_tag',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania tagu!'
            }
        });
})();
